import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { COLORS } from 'src/utils/Themes/colors'
import documentDownload from 'src/utils/commonMethods/documentDownload'
import download_icon from 'src/assets/Button_images/download.svg'
import CloseButton from 'src/components/common/CloseButton'
import { FILE_CATEGORY } from 'src/utils/constants/common'

const ViewDownloadReportFiles = ({
  category,
  policies,
  closeModal,
  downloadReportData,
}) => {
  const classes = useStyles()
  const [riskReportFiles, setRiskReportFiles] = useState([])
  const [quoteFiles, setQuoteFiles] = useState([])
  const [rfqFiles, setRfqFiles] = useState([])
  const [otherFiles, setOtherFiles] = useState([])

  useEffect(() => {
    if (downloadReportData) {
      setQuoteFiles(
        downloadReportData?.quotes ? downloadReportData?.quotes : []
      )
      setRiskReportFiles(
        downloadReportData?.riskReport ? downloadReportData?.riskReport : []
      )
      setRfqFiles(downloadReportData?.rfq ? downloadReportData?.rfq : [])
      setOtherFiles(
        downloadReportData?.others ? downloadReportData?.others : []
      )
    }
  }, [downloadReportData])

  const handleDocumentDownload = async (document, documentURL) => {
    documentDownload(document ? document : [], documentURL)
  }
  const filesArray = [
    {
      data: riskReportFiles,
      title: 'Reports',
      type: FILE_CATEGORY['Risk Report'],
    },
    { data: quoteFiles, title: 'Quotes', type: FILE_CATEGORY?.Quote },
    { data: rfqFiles, title: 'RFQs', type: FILE_CATEGORY?.RFQ },
    { data: otherFiles, title: 'Others', type: FILE_CATEGORY?.Others },
  ]

  const viewFiles = (data, title, type) => {
    return (
      <div className={classes.uploadedFilesContainer}>
        <span className={classes.heading}>{title}</span>
        <div className={classes.filesContainer}>
          {data?.length ? (
            data?.map((item, index) => uploadedFileDetails(item, index, type))
          ) : (
            <span className={classes.helperText}>No Uploaded Files.</span>
          )}
        </div>
      </div>
    )
  }

  const uploadedFileDetails = (item) => {
    return (
      <>
        <div className={classes.fileDetailsContainer}>
          <span>{item?.originalName}</span>
          <span>
            <img
              src={download_icon}
              title='Download File'
              alt='Download File'
              className={classes.downloadIcon}
              onClick={() => handleDocumentDownload([item], null)}
            />
          </span>
        </div>
      </>
    )
  }

  const policyFileDetails = (item) => {
    return (
      <>
        <div className={classes.fileDetailsContainer}>
          <span>
            {item?.productSubType === ''
              ? item?.insuranceType
              : item?.productSubType}
          </span>
          <span>
            <img
              src={download_icon}
              title='Download Policy'
              alt='Download Policy'
              className={classes.downloadIcon}
              onClick={() =>
                handleDocumentDownload(
                  item?.policyDocument,
                  item?.policyDocumentURL
                )
              }
            />
          </span>
        </div>
      </>
    )
  }

  return (
    <>
      <div className={classes.root}>
        <div className={classes.titleContainer}>
          <CloseButton
            id='closeButton'
            title='Close'
            handleClose={closeModal}
            classname={classes.clsBtn}
          />
          <h2 className={classes.title}>View Uploaded Files</h2>
        </div>

        <div className={classes.content}>
          {filesArray?.map((item) => {
            return viewFiles(item?.data, item?.title, item?.type)
          })}

          {category ? (
            <>
              <div className={classes.policyFilesContainer}>
                <span className={classes.heading}>Policy Files</span>
                <div className={classes.filesContainer}>
                  {policies?.map((item) => policyFileDetails(item))}
                </div>
              </div>
            </>
          ) : null}
        </div>
      </div>
    </>
  )
}

export default ViewDownloadReportFiles

const useStyles = makeStyles({
  clsBtn: {
    position: 'absolute',
    right: '25px',
  },
  root: {
    height: '100%',
  },
  titleContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  title: {
    fontSize: '18px',
    lineHeight: '22px',
    fontWeight: 'bold',
    color: '#333333',
    marginBottom: 'unset',
    padding: '5px',
  },
  content: {
    height: '85%',
    overflow: 'auto',
  },
  fileUploadContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  uploadedFilesContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    paddingBottom: '10px',
  },
  policyFilesContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  heading: {
    fontSize: '14px',
    lineHeight: '22px',
    fontWeight: 'bold',
    color: COLORS.DARK_PINK,
    marginBottom: '5px',
    textDecoration: 'underline',
  },
  helperText: {
    fontSize: '12px',
    fontStyle: 'italic',
    backgroundColor: COLORS.BACKGROUND_GREY,
    width: '100%',
    textAlign: 'center',
  },
  actionsContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: '10px',
    justifyContent: 'center',
    marginTop: '10px',
  },
  submitButton: {
    backgroundColor: COLORS.DARK_PINK,
    fontWeight: 'bold',
    '&:hover': {
      backgroundColor: COLORS.DARK_PINK,
    },
  },
  filesContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
    width: '100%',
    marginBottom: '5px',
  },
  fileDetailsContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  downloadIcon: {
    height: '20px',
    width: '25px',
    cursor: 'pointer',
  },
  inputContainer: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: '-20px',
    marginBottom: '25px',
    alignItems: 'center',
    // justifyContent: 'center',
    width: '100%',
  },
  inputLabel: {
    padding: '20px',
  },
  inputValue: {
    width: '40%',
  },
})
